<script>
export default {
  name: "ReferralNotesTab",

  props: {
    referral: Array,
    encounters: Array,
  },
};
</script>
<template>
  <div class="w-full flex flex-wrap p-1">
    <div v-for="encounter in encounters" :key="encounter.encounterId">
        <div 
          class="w-full flex flex-wrap p-2"
          v-if="referral.length &&
              referral.filter((ref) => ref.encounterID == encounter.encounterId)
                .length">
          <div class="w-full p-2 bg-gray-300">
            <h5 class="font-medium text-sm">Referral Note</h5>
          </div>
          <div class="w-full px-3 py-1">
            <div
              class="my-px"
              v-for="ref in referral.filter(ref => ref.encounterID == encounter.encounterId)"
              :key="ref.id"
            >
              <span v-html="ref.referralNotes"></span>
              <div class="w-full py-2">
                <h5 class="font-medium text-xs capitalize">Done By: {{ ref.userName }}</h5>
              </div>
            </div>
          </div>
        </div>
    </div>
  </div>
</template>
